// ---------------------------------------------------------------------------
// Contact Section
// ---------------------------------------------------------------------------
// Social links, contact blurb, and form settings.

import linkedinLogo from '../assets/contacts/LinkedIn_logo_initials.png';
import githubLogo from '../assets/contacts/github-logo.png';

const contact = {
  // Heading
  heading: 'Contact',

  // Social link buttons (rendered in order)
  socialLinks: [
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/jack-thoene/',
      icon: linkedinLogo,
    },
    {
      name: 'GitHub',
      url: 'https://github.com/jackthoene',
      icon: githubLogo,
    },
  ],

  // Blurb text above the form
  blurb:
    "Talk is cheap. Let's get to building. The form below will automatically send to my personal email. If you're ready to build something special, let's find the 80% solution and take off at a sprint together.",

  // Formspree endpoint
  formEndpoint: 'https://formspree.io/f/xdoprgpv',

  // Form placeholder text
  formPlaceholders: {
    name: 'Name',
    email: 'Email',
    message: 'Message',
  },

  // Validation error messages
  formErrors: {
    name: 'Please enter your name.',
    email: 'Please enter a valid email.',
    message: 'Please enter a message.',
  },
};

export default contact;
